import styled from "styled-components";

const StyledFooterLogo = styled.img`
    position: absolute;
    width: 9rem;
    bottom: 5.5rem;
    @media print {
        position: fixed;
        bottom: 2.5rem;
    }
`;

export default StyledFooterLogo;
